import React from 'react';
// Importez vos images personnalisées
import snapchatIcon from './image/snapchat.png';
import instagramIcon from './image/instagram.png';
import facebookIcon from './image/facebook.png';
import tiktokIcon from './image/tiktok.png';

const Footer = ({ navigateTo, currentPage }) => {
    return (
        <footer className="bg-gray-800 py-6 px-6 md:px-12 lg:px-24">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="flex flex-col items-start">
                    <p className="text-lg font-semibold mb-2 text-white font-bold">Sev Remorque</p>
                    <p className="text-gray-300 text-sm">
                        Nous assurons des services de remorquage et d'enlèvement rapides de véhicules dans toutes
                        les conditions sur l'ensemble de la région Occitanie.
                    </p>
                </div>
                <div className="flex flex-col items-start">
                    <p className="text-lg font-semibold mb-2 text-white font-bold">En savoir plus ?</p>
                    <ul className="text-gray-300 text-sm space-y-1">
                        <li>
                            <button
                                onClick={() => navigateTo('mentions')}
                                className={`hover:text-blue-500 transition-colors ${currentPage === 'mentions' ? 'font-bold' : ''}`}
                            >
                                Mentions Légales
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => navigateTo('politique')}
                                className={`hover:text-blue-500 transition-colors ${currentPage === 'politique' ? 'font-bold' : ''}`}
                            >
                                Politique de confidentialité
                            </button>
                        </li>
                        <li>
                            <button
                                onClick={() => navigateTo('cookies')}
                                className={`hover:text-blue-500 transition-colors ${currentPage === 'cookies' ? 'font-bold' : ''}`}
                            >
                                Politique de cookies
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col items-start">
                    <div className="flex flex-col items-start">
                        <a
                            href="tel:0699463159"
                            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full text-lg font-bold transition-colors self-start mb-4 text-center"
                        >
                            Contactez-nous maintenant
                            <br />
                            06 99 46 31 59
                        </a>
                        <div
                            className="flex justify-center items-center gap-4"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                            }}
                        >
                            <a href="#" className="hover:text-blue-500 transition-colors">
                                <img
                                    src={snapchatIcon}
                                    alt="Snapchat"
                                    className="w-6 h-6"
                                    style={{ verticalAlign: 'middle' }}
                                />
                            </a>
                            <a href="#" className="hover:text-blue-500 transition-colors">
                                <img
                                    src={instagramIcon}
                                    alt="Instagram"
                                    className="w-6 h-6"
                                    style={{ verticalAlign: 'middle' }}
                                />
                            </a>
                            <a href="#" className="hover:text-blue-500 transition-colors">
                                <img
                                    src={facebookIcon}
                                    alt="Facebook"
                                    className="w-6 h-6"
                                    style={{ verticalAlign: 'middle' }}
                                />
                            </a>
                            <a href="#" className="hover:text-blue-500 transition-colors">
                                <img
                                    src={tiktokIcon}
                                    alt="TikTok"
                                    className="w-6 h-6"
                                    style={{ verticalAlign: 'middle' }}
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-6 text-center text-gray-400 text-sm">
                &copy; Tous droits réservés. Réalisé par Sev Remorque
            </div>
        </footer>
    );
};

export default Footer;